import React from "react";
import { Form } from "react-bootstrap";

const SelectSituacao = ({ formik, field }) => (
  <>
    <Form.Control
      as="select"
      id={field}
      name={field}
      disabled={formik.isSubmitting}
      value={formik.values[field]}
      onChange={formik.handleChange}
      isInvalid={formik.touched[field] && formik.errors[field]}
    >
      <option key="0" value="">
        Selecione
      </option>
      <option key="A" value="A">
        Ativo
      </option>
      <option key="I" value="I">
        Inativo
      </option>
    </Form.Control>
    {formik.touched[field] && formik.errors[field] && (
      <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
    )}
  </>
);

export default SelectSituacao;
